import { Link, Outlet } from "react-router-dom";
import { LogOut } from "lucide-react";
import { useAuth, useLang } from "@/context/AuthContext";
import { BrandMark, LangSwitch } from "@/components/Brand";
import { t } from "@/lib/i18n";

export default function DriverLayout() {
  const { user, logout } = useAuth();
  const [lang, setLang] = useLang();
  return (
    <div className="relative z-10 mx-auto min-h-screen max-w-md pb-10">
      <header className="sticky top-0 z-30 flex items-center gap-3 border-b border-white/10 bg-[#0A0E17]/90 px-4 py-3 backdrop-blur-xl">
        <Link to="/driver" data-testid="driver-home-link"><BrandMark className="h-9" /></Link>
        <div className="min-w-0 flex-1 leading-tight">
          <div className="truncate text-sm font-semibold" data-testid="driver-name">{user?.name}</div>
          <div className="truncate font-mono text-[10px] uppercase text-slate-500">{user?.truck || "M-Line Solutions"}</div>
        </div>
        <LangSwitch lang={lang} setLang={setLang} />
        <button onClick={logout} data-testid="driver-logout-btn" title={t(lang, "logout")} className="rounded-full p-2 text-slate-400 hover:bg-white/5 hover:text-white">
          <LogOut className="h-4 w-4" />
        </button>
      </header>
      <main className="px-4 pt-5">
        <Outlet context={{ lang }} />
      </main>
    </div>
  );
}
